/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ComplianceSummaryByPoliciesRequest {
    getFixupPrototypeFunction() { return ComplianceSummaryByPoliciesRequest.fixupPrototype; }

    static newInstance(model: Partial<ComplianceSummaryByPoliciesRequest>): ComplianceSummaryByPoliciesRequest {
        let obj = Object.assign(new ComplianceSummaryByPoliciesRequest(), model);
        ComplianceSummaryByPoliciesRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ComplianceSummaryByPoliciesRequest>): ComplianceSummaryByPoliciesRequest {
        if (!model) return null;
        return ComplianceSummaryByPoliciesRequest.newInstance(<ComplianceSummaryByPoliciesRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ComplianceSummaryByPoliciesRequest) {
        if (!obj) return;

        models.ComplianceSummaryByPoliciesRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ComplianceSummaryByPoliciesRequest): boolean {
        Object.setPrototypeOf(obj, ComplianceSummaryByPoliciesRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Specify the tenant ID. This is a unique ID and can be retrieved using the List Tenants API
     */
    tenant_id: Array<string>;

    /**
     * compliance standards to filter policies
     */
    standards: Array<string>;

    /**
     * policies to  filter
     */
    policy_id: Array<string>;

    /**
     * Allowed services
     */
    services: Array<models.CloudServiceName>;

    /**
     * ID of the cloud account. This can be fetched from list cloud accounts API
     */
    cloud_accounts: Array<string>;

    /**
     * severities to filter policies
     */
    severity: Array<string>;

    /**
     * resource types to filter policies
     */
    resource_type: Array<string>;

}
